import type { EditorTextareaFormValues } from "./schema-builder-field-editor-textarea.type";
import type { GetEditorValuesOptions } from "../schema-builder-field-editor.type";
import type { SchemaFieldTextarea } from "@/entities/schema";

import { isEqualNumber, isValidNumber } from "@/utilities/number";

import {
  getEditorDefaultValues,
  getNewSchemaFieldOptionsFromValues,
  isEditorDefaultFormValuesEqual,
} from "../schema-builder-field-editor-default";

export const getEditorTextareaValues = (
  options: GetEditorValuesOptions
): EditorTextareaFormValues => {
  const { schema } = options;

  const values: EditorTextareaFormValues = {
    fieldType: "textArea",
    ...getEditorDefaultValues(options),
  };

  if (schema.type !== "textArea") return values;

  if (isValidNumber(schema.max)) values.max = schema.max;
  if (isValidNumber(schema.rows)) values.rows = schema.rows;

  return values;
};

export const isEditorTextareaFormValuesEqual = (
  a: EditorTextareaFormValues,
  b: EditorTextareaFormValues
) => {
  if (!isEditorDefaultFormValuesEqual(a, b)) return false;
  if (!isEqualNumber(a.max, b.max)) return false;
  if (!isEqualNumber(a.rows, b.rows)) return false;
  return true;
};

export const getNewSchemaTextareaFromValues = (
  values: EditorTextareaFormValues
): SchemaFieldTextarea => {
  const schema: SchemaFieldTextarea = {
    type: "textArea",
    ...getNewSchemaFieldOptionsFromValues(values),
  };

  if (isValidNumber(values.max)) schema.max = values.max;
  if (isValidNumber(values.rows)) schema.rows = values.rows;

  return schema;
};
